// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';

/**
 * Deletes an existing file from a fulfillment order.
 *
 * @param fulfillmentKey - The key of the fulfillment order.
 * @param fileKey - The key of the file.
 */
export async function deleteFulfillmentFile(
  fulfillmentKey: string,
  fileKey: string
) {
  const path = `/v1/fulfillment/${fulfillmentKey}/file/${fileKey}`;
  const response = await api.delete(path);

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'DeleteFulfillmentFile',
    endpoint: path,
  });
}
